// extracted by mini-css-extract-plugin
export default {"confirm_area":"Confirm_confirm_area__0jjsR","contents":"Confirm_contents__n90J7","btn_wrapper":"Confirm_btn_wrapper__evlbx","contact_area":"Confirm_contact_area__Z9cxA"};